import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    template: `
      <h2 mat-dialog-title>Recipient Details <span *ngIf="data.filter">({{data.filter}})</span></h2>
      <mat-dialog-content>
            <mat-list *ngIf="histories">
                <mat-list-item *ngFor="let history of histories" style="height: 28px;">{{history}}</mat-list-item>
                <mat-list-item *ngIf="!histories?.size && !data.filter">No Recipients</mat-list-item>
                <mat-list-item *ngIf="!histories?.size && data.filter">No Recipients for {{data.filter}} status</mat-list-item>
            </mat-list>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button mat-dialog-close color="primary">Done</button>
      </mat-dialog-actions>
      `
})
export class BriefingHistoryDetailsDialogComponent implements OnInit {
    histories: Set<string>;
    

    constructor(@Inject(MAT_DIALOG_DATA) public data: { history: { activities: { activity: string, emailAddress: string }[]}, filter?: string}) {}

    ngOnInit(): void {
        this.histories = new Set((this.data.history.activities || [])
            .filter(history => !this.data.filter || history.activity.endsWith(this.data.filter))
            .map(hist => hist.emailAddress)
            .sort((a, b) => a.localeCompare(b)));
    }

    activityDisplay(activity: string): string {
        const retVal = activity.substring(activity.lastIndexOf('_') + 1);
        return retVal.charAt(0).toUpperCase() + retVal.slice(1);;
    }
}